module.exports = __webpack_public_path__ + "img/ico-refresh.1cdefa33.svg";